// extracted by mini-css-extract-plugin
module.exports = {"AdminActions":"AdminActions_AdminActions__y7qMX","AdminActions__to-admin-page":"AdminActions_AdminActions__to-admin-page__xf9ke"};